import React from 'react';
import {useNavigate} from 'react-router-dom';
import {useTranslation} from "react-i18next";
import {Footer} from "@/components/Footer.jsx";
import {QuizRulesSection} from "@/features/quiz/QuizRulesSection.jsx";
import {ReferralRulesSection} from "@/features/referral/ReferralRulesSection.jsx";

export const RugbyRulesPage = () => {
    const {t} = useTranslation();
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-slate-50 flex flex-col font-sans">
            {/* Header Global GOJO */}
            <div className="bg-brand-dark pt-12 pb-20 text-center">
                <div className="mb-10 flex flex-col items-center">
                    <h1 className="text-4xl font-black text-white mt-4 tracking-tight">
                        GOJO<span className="text-[#FBBF24]">.</span>
                    </h1>
                </div>
            </div>

            <div className="max-w-110 mx-auto w-full px-6 -mt-10 relative z-20 mb-10">
                <div className="bg-white rounded-3xl p-8 shadow-xl border border-gray-50">
                    <h2 className="text-xl font-black text-gray-900 mb-6 uppercase tracking-tight">
                        {t('rugby_rules.title')}
                    </h2>

                    <div className="space-y-6 text-sm text-gray-600 leading-relaxed">

                        {/* 1. GRATUITÉ */}
                        <section>
                            <h3 className="font-bold text-gray-800 uppercase text-xs mb-2 tracking-wider">
                                {t('rugby_rules.free_title')}
                            </h3>
                            <p>{t('rugby_rules.free_content')}</p>
                        </section>

                        {/* 2. POINTS (SPÉCIFIQUE RUGBY) */}
                        <section>
                            <h3 className="font-bold text-gray-800 uppercase text-xs mb-2 tracking-wider">
                                {t('rugby_rules.points_title')}
                            </h3>
                            <p className="mb-2">{t('rugby_rules.points_intro')}</p>

                            {/* Formule Mathématique */}
                            <div
                                className="bg-slate-50 border border-slate-100 rounded-xl p-3 font-bold text-gray-800 text-center mb-4 text-xs sm:text-sm">
                                {t('rugby_rules.points_formula')}
                            </div>

                            {/* Info Cotes */}
                            <div
                                className="bg-blue-50 border border-blue-100 rounded-lg p-3 mb-4 flex items-start gap-3">
                                <span className="text-lg">📈</span>
                                <p className="text-[12px] text-blue-800 leading-snug">
                                    <strong>{t('rugby_rules.odds_title')}</strong> {t('rugby_rules.odds_content')}
                                </p>
                            </div>

                            {/* Détails Vainqueur & Marge */}
                            <ul className="space-y-3">
                                <li className="flex gap-3 bg-green-50/50 p-2 rounded-lg border border-green-50">
                                    <span className="text-lg">🏆</span>
                                    <span className="text-xs">
                                        <strong>{t('rugby_rules.winner_label')}</strong> {t('rugby_rules.winner_content')}
                                    </span>
                                </li>
                                <li className="flex gap-3 bg-amber-50/50 p-2 rounded-lg border border-amber-50">
                                    <span className="text-lg">📐</span>
                                    <span className="text-xs">
                                        <strong>{t('rugby_rules.margin_label')}</strong> {t('rugby_rules.margin_content')}
                                    </span>
                                </li>
                            </ul>
                        </section>

                        <QuizRulesSection/>

                        {/* Prono mi-temps (optionnel — activé par l'établissement) */}
                        <section>
                            <h3 className="font-bold text-gray-800 uppercase text-xs mb-2 tracking-wider">
                                {t('rugby_rules.ht_title')}
                            </h3>
                            <p className="mb-3">{t('rugby_rules.ht_intro')}</p>
                            <div className="bg-amber-50 border border-amber-100 rounded-lg p-3 mb-3 flex items-start gap-3">
                                <span className="text-lg">🔒</span>
                                <p className="text-[12px] text-amber-800 leading-snug">{t('rugby_rules.ht_rule')}</p>
                            </div>
                            <p className="mb-2">{t('rugby_rules.ht_win')}</p>
                            <p className="text-[12px] text-gray-400 italic">📍 {t('rugby_rules.ht_availability')}</p>
                        </section>

                        {/* 3. ÉGALITÉ (Précision > Vitesse) */}
                        <section>
                            <h3 className="font-bold text-gray-800 uppercase text-xs mb-2 tracking-wider">
                                {t('rugby_rules.equality_title')}
                            </h3>
                            <p>{t('rugby_rules.equality_content')}</p>
                        </section>

                        {/* 4. CADEAUX */}
                        <section>
                            <h3 className="font-bold text-gray-800 uppercase text-xs mb-2 tracking-wider">
                                {t('rugby_rules.prizes_title')}
                            </h3>
                            <p>{t('rugby_rules.prizes_content')}</p>
                        </section>

                        <ReferralRulesSection/>

                        {/* 5. FRAUDE */}
                        <section>
                            <h3 className="font-bold text-gray-800 uppercase text-xs mb-2 tracking-wider">
                                {t('rugby_rules.fraud_title')}
                            </h3>
                            <p>{t('rugby_rules.fraud_content')}</p>
                        </section>
                    </div>

                    <button
                        onClick={() => navigate(-1)}
                        className="w-full mt-8 py-4 bg-brand-dark text-white font-bold rounded-xl shadow-lg hover:brightness-110 active:scale-95 transition-all"
                    >
                        {t('rugby_rules.back_btn')}
                    </button>
                </div>
            </div>

            <Footer contestType="RUGBY"/>
        </div>
    );
};